import React, { MutableRefObject, RefObject, useEffect, useState } from 'react';
import { findNodeHandle } from 'react-native';

/**
 * Custom hook to get native node handle from ref.
 * This is used in order to have nextFocus* working with react-native-web
 *
 * @param ref
 * @returns {unknown}
 */

type TypeOfReference = null | number | React.Component<unknown, unknown> | React.ComponentClass<unknown>;

export const useNodeHandle = (reference?: RefObject<TypeOfReference> | null | number) => {
  const [nodeHandle, setNodeHandle] = useState<null | number>(null);

  useEffect(() => {
    const refElement = getRefElement(reference);

    if (refElement) {
      setNodeHandle(findNodeHandle(refElement));
    }
  }, [reference]);

  return nodeHandle;
};

export const useNodeHandleFromIndex = (
  reference: MutableRefObject<Record<number, TypeOfReference>>,
  index?: number,
) => {
  const [nodeHandle, setNodeHandle] = useState<null | number>(null);

  const refElement = typeof index === 'undefined' ? null : reference?.current[index];

  useEffect(() => {
    if (refElement) {
      setNodeHandle(findNodeHandle(refElement));
    }
  }, [refElement]);

  return nodeHandle;
};

const getRefElement = (reference?: RefObject<TypeOfReference> | null | number) => {
  if (typeof reference === 'number' || typeof reference === 'undefined' || reference === null) {
    return null;
  }
  return reference.current;
};
